import type { DesktopState } from '../state';

export function Navbar({ s, onOpen, onLogout }: { s: DesktopState; onOpen: (m: DesktopState['modal']) => void; onLogout: () => void }) {
  const wp = s.webphone;
  return (
    <div id="x5-navbar">
      <span className="logo">Agent Desktop</span>
      <button onClick={() => onOpen('calllog')}>Call Log</button>
      <button onClick={() => onOpen('callbacks')}>Callbacks</button>
      <button onClick={() => onOpen('pause')} disabled={s.agentState === 'on_call' || s.agentState === 'reserved'}>Enter Pause Code</button>
      {s.config?.manual_dial && s.config.manual_dial !== 'NONE' && (
        <button id="manual-dial-open" onClick={() => onOpen('manualdial')} disabled={s.agentState === 'on_call' || s.agentState === 'reserved'}>Manual Dial</button>
      )}
      <button disabled title="Phase 4">Agent Chat</button>
      <span className="spacer" />
      <span className={`badge ${wp === 'in-room' ? 'ok' : wp === 'failed' ? 'bad' : 'warn'}`}>{wp === 'in-room' ? 'Phone: in room' : wp === 'registered' ? 'Phone: registered' : wp === 'registering' ? 'Phone: registering…' : wp === 'failed' ? 'Phone: down' : 'Phone: off'}</span>
      <span className={`badge ${s.upstream ? 'ok' : 'bad'}`}>{s.upstream ? 'Events: live' : 'Events: reconnecting'}</span>
      <span className="who">{s.session?.agent_id} · {s.config?.name}</span>
      <button onClick={onLogout}>Logout</button>
    </div>
  );
}
